import rq from '@/request'

const resource = 'fine-play-groups'
const get = (params) => rq.get(`${resource}`, {params})
const show = (id) => rq.get(`${resource}/${id}`)
const approve = (id) => rq.post(`${resource}/${id}/approve`)
const denial = (id) => rq.post(`${resource}/${id}/denial`)
const store = (data) => rq.post(`fine-plays`, data)
const count = () => rq.get(`${resource}/count`)

export default {
  get,
  show,
  approve,
  denial,
  store,
  count
}



// WEBPACK FOOTER //
// ./src/api/fine-plays.js